import React from "react";

const OrderLoader = ({ size = 60, color = "#ff0000", text = "" }) => {
  const dotSize = size / 4;

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "30vh",
    color: "#333",
    textAlign: "center",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  };

  const dotsWrapper = {
    display: "flex",
    gap: dotSize / 1.5,
  };

  const dotStyle = {
    width: `${dotSize}px`,
    height: `${dotSize}px`,
    borderRadius: "50%",
    backgroundColor: color,
    animation: "bounce 0.6s infinite alternate",
  };

  return (
    <div style={containerStyle}>
      <div style={dotsWrapper}>
        <div style={{ ...dotStyle, animationDelay: "0s" }}></div>
        <div style={{ ...dotStyle, animationDelay: "0.2s" }}></div>
        <div style={{ ...dotStyle, animationDelay: "0.4s" }}></div>
      </div>
      <h2 style={{ fontWeight: 600, fontSize: "1.2rem", color }}>{text}</h2>

      <style>
        {`
          @keyframes bounce {
            0% { transform: translateY(0); opacity: 0.5; }
            100% { transform: translateY(-8px); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default OrderLoader;
